import React, {useState} from 'react';
import DemandCreate from "../../components/crud/DemandCreate";
import Main from "../../components/main/Main";
import DemandList from "../../components/list/DemandList";
import { useTranslation } from 'react-i18next';                   /* Added Line */

function CommonPage(props) {
    const [refreshList, setRefreshList] = useState(false);
    const [updateButtonClicked, setUpdateButtonClicked] = useState(false);
    const [selectedRow, setSelectedRow] = useState(false);

    const onUpdateButtonClicked = (selectedRow) => {
        setUpdateButtonClicked(true);
        setSelectedRow(selectedRow)
    }

    return (
        <Main>
            <DemandCreate 
                type={props.type} 
                talepTurId={props.talepTurId} 
                tarafText={props.tarafText}
                davaliText={props.davaliText}
                bedelTitle={props.bedelTitle}
                tahminiBedelTitle={props.tahminiBedelTitle}
                updateButtonClicked={updateButtonClicked} 
                setUpdateButtonClicked={setUpdateButtonClicked} 
                selectedRow={selectedRow} 
                refreshList={refreshList} 
                setRefreshList={setRefreshList} 
                pageTitle={props.pageTitle}
            />
            <DemandList 
                refreshList={refreshList} 
                onUpdateButtonClicked={onUpdateButtonClicked} 
                setRefreshList={setRefreshList} 
                talepTurId={props.talepTurId} 
            />
        </Main>
    );
}

export default CommonPage;